import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {ChakraProvider} from "@chakra-ui/react"
import {BrowserRouter} from "react-router-dom"
import { Provider } from 'react-redux';
import { store } from './ReduxStore/Store';
import { SearchContextProvider } from './Context/SearchContext';
import { LoginContextProvider } from './Context/LoginContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LoginContextProvider>
    <SearchContextProvider>
      <ChakraProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </SearchContextProvider>
    </LoginContextProvider>
  </Provider>
);

